import axios from '@/jslib/axios'
import {productAPiPath} from '@/utils/smePath'
export const addReferral = data => {
  return axios({
    method: 'post',
    url: '/admin/referral/add',
    data
  })
}

// refer 詳情
export const getCoressReferDetail = (params,productId=11) => {
  return axios({
    method: 'get',
    url: `/admin/order/${productAPiPath[productId]}/refer/detail`,
    params
  })
}
export const getCarReferDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/order/car/refer/detail',
    params
  })
}

export const getHousemaidReferDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/order/housemaid/refer/detail',
    params
  })
}

export const getInteriorReferDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/order/interior/refer/detail',
    params
  })
}

export const getHomefireReferDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/order/home_fire/refer/detail',
    params
  })
}
export const getTravelReferDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/order/travel/refer/detail',
    params
  })
}
export const getWorkingReferDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/order/holiday/refer/detail',
    params
  })
}
export const getStudentReferDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/order/student/refer/detail',
    params
  })
}
export const getPersonalReferDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/order/accident/refer/detail',
    params
  })
}
export const getPetReferDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/order/pet/refer/detail',
    params
  })
}

// 回復報價計算
export const getReferralMain = data => {
  return axios({
    method: 'post',
    url: '/admin/referral/main',
    data
  })
}
// save draft
export const replyReferral = data => {
  return axios({
    method: 'post',
    url: '/admin/referral/reply',
    data
  })
}

// 回復報價公司
export const getReferralReplyCase = params => {
  return axios({
    method: 'get',
    url: '/admin/referral/reply/case',
    params
  })
}

// 狀態變更
export const changeReferralStts = data => {
  return axios({
    method: 'post',
    url: '/admin/referral/chg_stts',
    data
  })
}

// 購買報價列表
export const getReferralBuyQuote = data => {
  return axios({
    method: 'post',
    url: '/admin/referral/buy/quote',
    data
  })
}

// 購買保單
export const referralBuyPolicy = data => {
  return axios({
    method: 'post',
    url: '/admin/referral/buy/policy',
    data
  })
}

export const getReferWaitingPurchaseList = params => {
  return axios({
    method: 'get',
    url: '/admin/referral/waiting/purchase/list',
    params
  })
}

// refer 獲取優惠報價，重新獲取報價數據
export const referQuoteApplyCode = data => {
  return axios({
    method: 'post',
    url: '/admin/referral/quote/apply/code',
    data
  })
}

// refer 單應用優惠碼
export const referApplyCode = data => {
  return axios({
    method: 'post',
    url: '/admin/referral/order/apply/code',
    data
  })
}

export const getReferralRewardsList = params => {
  return axios({
    method: 'get',
    url: '/admin/referral/rewards/list',
    params
  })
}

export const getReferralHomeExcess = data => {
  return axios({
    method: 'post',
    url: '/admin/referral/home/excess',
    data
  })
}

export const sendReferralSms = data => {
  return axios({
    method: 'post',
    url: '/admin/referral/send/sms',
    data
  })
}

export const getReferralPersonalCoverage = data => {
  return axios({
    method: 'post',
    url: '/admin/referral/accident/cvr_opt',
    data
  })
}
export const getReferralPersonalBenifit = data => {
  return axios({
    method: 'post',
    url: '/admin/referral/accident/benefit_opt',
    data
  })
}
export const getReferralPlanBenefit = data => {
  return axios({
    method: 'post',
    url: '/admin/referral/plan/benefit',
    data
  })
}
export const getReferralExtra = params => {
  return axios({
    method: 'get',
    url: '/admin/referral/extra/optional',
    params
  })
}
export const getReferenceQuote = params => {
  return axios({
    method: 'get',
    responseType: 'blob',
    url: '/admin/refer/quote/reference',
    params,
    timeout: 120000
  })
}
export const getReferralQuoteDel = data => {
  return axios({
    method: 'delete',
    url: '/admin/referral/quote/del',
    data
  })
}
export const getReferralUnderwriting = params => {
  return axios({
    method: 'get',
    url: '/admin/referral/plan/optional',
    params
  })
}

export const getTranscriptsDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/commission/transcripts/detail',
    params
  })
}
